module.exports = __webpack_public_path__ + "img/04_Paddy_Productivity_II_s.2d834e0b.png";